import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

import TeamRegister from './component'
import NonMasterPage from './NonMasterPage'

import { registerTeam } from '../../../redux/team'

import { lockScreen } from '../../../redux/game'

class TeamRegisterContainer extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      name: '',
      strategy: ''
    }
  }

  handleConfirm = () => {
    this.props.registerTeam(
      this.props.teamId,
      this.state.name,
      this.state.strategy
    )
  }

  handleNameUpdate = (val) => {
    this.setState({ name: val })
  }

  handleStrategyUpdate = (val) => {
    this.setState({ strategy: val })
  }

  render () {
    if (!this.props.isMaster) {
      return <NonMasterPage lockScreen={this.props.lockScreen} />
    }
    const buttonEnabled = !!this.state.name && !!this.state.strategy
    return (
      <TeamRegister
        error={this.props.registerError}
        onConfirm={this.handleConfirm}
        onNameUpdate={this.handleNameUpdate}
        onStrategyUpdate={this.handleStrategyUpdate}
        name={this.state.name}
        strategy={this.state.strategy}
        buttonEnabled={buttonEnabled}
        registering={this.props.registering}
        lockScreen={this.props.lockScreen}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  teamId: state.team.id,
  isMaster: state.device.isMaster,
  registered: state.team.registered,
  registering: state.team.registering,
  registerError: state.team.error
})

export default connect(mapStateToProps, {
  registerTeam,
  lockScreen
})(TeamRegisterContainer)
